const agencesEndpoints = {
  // Grande taille de page : cet ecran affiche tout le referentiel, pas de pagination UI pour l'instant.
  list: () => "/bank/agences?page=0&size=500",
};

export default agencesEndpoints;
